import { IMilestone } from "@/interfaces";

export const addScheduleNameToMilestonesRecursive = (
  scheduleName: string,
  milestones: IMilestone[]
): IMilestone[] => {
  const updatedMilestone = milestones.map((milestone) => ({
    ...milestone,
    scheduleName,
  }));

  updatedMilestone.forEach((parentMilestone) => {
    if (!parentMilestone?.childMilestones?.length) return;

    parentMilestone.childMilestones = addScheduleNameToMilestonesRecursive(
      scheduleName,
      parentMilestone.childMilestones
    );
  });

  return updatedMilestone;
};
